export const SET_DEVICE = "SET_DEVICE";

export const setDevice = width => ({
  type: SET_DEVICE,
  width
});
